export const HomepageBannerType = [
  {
    type: 10,
    name: "홈 메인",
  },
];
